import { isPVCWall } from '../DataStructures/wallTypes';
import { isPVCRoof } from '../DataStructures/roofTypes';

export function addOptionRulesHandler(configuration, store) {
  configuration.onImmediatePropChange(({ data: { prop, value, state } }) => {
    const storeState = store.getState();
    // "pvc wall" requires the roof type to be "pvc roof with pvc gable"
    if (prop === 'wallType' && isPVCWall(value)) {
      state.roofType = storeState.Option.localOptions.roof.find(isPVCRoof);
    }
    // "pvc wall" is not compatible with other roof types, so the first compatible wall type is selected
    if (prop === 'roofType' && !isPVCRoof(value) && isPVCWall(state.wallType)) {
      state.wallType = storeState.Option.localOptions.walls.find((wall) => !isPVCWall(wall));
    }
  });
}
